import PasswordStrength from './PasswordStrength';

export default function (Vue, options = {}) {
    Vue.component('password-strength', PasswordStrength);

    window.passwordStrength = Object.assign({
        startHue: 0,
        finishHue: 110,
        saturation: 0.75,
        lightness: 0.5,
        errorTextClass: 'text-red',
    }, options);
}
